import { useSelector } from "react-redux";
import { selectCurrent as selectUserCurrent } from "../../../../redux/user/selectors";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { user } from "../../../../redux/user/actions";
import { useNavigate } from "react-router-dom";
import ProfileAddress from "../../../../models/ProfileAddress";
import storePersist from "../../../../redux/storePersist";
import { addressBooks } from "../../../../redux/address-books/action";
import { selectaddressBooksListItems } from "../../../../redux/address-books/selector";
import EditProfileAddress from "../../../../models/EditProfileAddress";



const CustomerAddressBookMobile = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const { viewProfile, editProfile } = useSelector(selectUserCurrent)
	const [color, setColor] = useState('universal')
	const itemsData = useSelector(selectaddressBooksListItems)
	const [addressBookId, setAddressBookId] = useState<any>({})
	const [currentAddress, setCurrentAddress] = useState<any>({})

	const handleAddress = () => {
		dispatch(user.set({ viewProfile: 'open' }))
	}

	const userProfileData = storePersist?.get("userProfile")?.current;

	useEffect(() => {
		if (viewProfile == 'close') {

		}
		dispatch(addressBooks.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/query`, entity: 'addressBooks', jsonData: {

				"Records": [
					{
						"Id": userProfileData?.items[0]?.Message?.AddressBookId
					}
				]

			}
		}))
	}, [viewProfile]);



	const editAddress = (address: any) => {
		const userProfileData = storePersist?.get("userProfile")?.current;
		setAddressBookId(userProfileData?.items[0]?.Message?.AddressBookId);
		setCurrentAddress(address);
		dispatch(user.set({ editProfile: 'open' }))
	}

	return (

		<div className=" h-auto flex flex-col justify-between items-stretch bg-white ">

			<div className="w-full  justity-center items-center mb-5">

				{itemsData?.isLoading ? <div className="flex items-center justify-center mt-20">Loading... </div> :
					<div className="flex flex-col z-0  p-5 ">
						<div className="flex w-full flex-col items-start justify-between uppercase text-xl " >
							Manage Address
						</div>
						{viewProfile == 'open' ? <ProfileAddress /> : ""}
						{editProfile == 'open' ? <EditProfileAddress addressBookId={addressBookId} address={currentAddress} /> : ""}

						{(viewProfile == 'close' && editProfile == 'close') && <>
							<div className="flex justify-end w-full p-2">
								<button
									onClick={() => handleAddress()}
									className={`bg-primary text-light rounded-md p-2 px-5 font-semibold`}>
									+ Add Address
								</button>
							</div>
							<div className="h-[65vh] overflow-y-auto scrollbar-hide pb-5">
								{itemsData?.result?.items[0]?.Addresses.map((addressData: any) => (
									<div className="border border-black rounded m-2 ">
										<div className={`text-primary p-1 px-3 hover:cursor-pointer`}>
											<div className="flex justify-between">
												<span>{addressData?.FirstName} {addressData?.LastName}</span>
												<svg xmlns="http:www.w3.org/2000/svg" onClick={() => { editAddress(addressData) }} width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>
											</div>
										</div>
										<div className="p-2 space-y-2">
											{/* Address Row */}
											<div className="flex items-center">
												<svg version="1.1" className="h-6 w-6" fill="currentColor" id="Capa_1" viewBox="0 0 293.334 293.334">
													<path d="M146.667,0C94.903,0,52.946,41.957,52.946,93.721c0,22.322,7.849,42.789,20.891,58.878
														c4.204,5.178,11.237,13.331,14.903,18.906c21.109,32.069,48.19,78.643,56.082,116.864c1.354,6.527,2.986,6.641,4.743,0.212
														c5.629-20.609,20.228-65.639,50.377-112.757c3.595-5.619,10.884-13.483,15.409-18.379c6.554-7.098,12.009-15.224,16.154-24.084
														c5.651-12.086,8.882-25.466,8.882-39.629C240.387,41.962,198.43,0,146.667,0z M146.667,144.358
														c-28.892,0-52.313-23.421-52.313-52.313c0-28.887,23.421-52.307,52.313-52.307s52.313,23.421,52.313,52.307
														C198.98,120.938,175.559,144.358,146.667,144.358z"
													/>
													<circle cx="146.667" cy="90.196" r="21.756" />
												</svg>
												<span className="ml-2">
													{addressData?.Address1}, {addressData?.Address2}, {addressData?.City}, {addressData?.StateProvince?.Name} - {addressData?.ZipPostalCode}
												</span>
											</div>
											{/* Phone Row */}
											<div className="flex items-center">
												<svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" >
													<path d="M15.5562 14.5477L15.1007 15.0272C15.1007 15.0272 14.0181 16.167 11.0631 13.0559C8.10812 9.94484 9.1907 8.80507 9.1907 8.80507L9.47752 8.50311C10.1841 7.75924 10.2507 6.56497 9.63424 5.6931L8.37326 3.90961C7.61028 2.8305 6.13596 2.68795 5.26145 3.60864L3.69185 5.26114C3.25823 5.71766 2.96765 6.30945 3.00289 6.96594C3.09304 8.64546 3.81071 12.259 7.81536 16.4752C12.0621 20.9462 16.0468 21.1239 17.6763 20.9631C18.1917 20.9122 18.6399 20.6343 19.0011 20.254L20.4217 18.7584C21.3806 17.7489 21.1102 16.0182 19.8833 15.312L17.9728 14.2123C17.1672 13.7486 16.1858 13.8848 15.5562 14.5477Z" fill="#1C274C" />
													<path d="M13.2595 1.87983C13.3257 1.47094 13.7122 1.19357 14.1211 1.25976C14.1464 1.26461 14.2279 1.27983 14.2705 1.28933C14.3559 1.30834 14.4749 1.33759 14.6233 1.38082C14.9201 1.46726 15.3347 1.60967 15.8323 1.8378C16.8286 2.29456 18.1544 3.09356 19.5302 4.46936C20.906 5.84516 21.705 7.17097 22.1617 8.16725C22.3899 8.66487 22.5323 9.07947 22.6187 9.37625C22.6619 9.52466 22.6912 9.64369 22.7102 9.72901C22.7197 9.77168 22.7267 9.80594 22.7315 9.83125L22.7373 9.86245C22.8034 10.2713 22.5286 10.6739 22.1197 10.7401C21.712 10.8061 21.3279 10.53 21.2601 10.1231C21.258 10.1121 21.2522 10.0828 21.2461 10.0551C21.2337 9.9997 21.2124 9.91188 21.1786 9.79572C21.1109 9.56339 20.9934 9.21806 20.7982 8.79238C20.4084 7.94207 19.7074 6.76789 18.4695 5.53002C17.2317 4.29216 16.0575 3.59117 15.2072 3.20134C14.7815 3.00618 14.4362 2.88865 14.2038 2.82097C14.0877 2.78714 13.9417 2.75363 13.8863 2.7413C13.4793 2.67347 13.1935 2.28755 13.2595 1.87983Z" fill="#1C274C" />
													<path fillRule="evenodd" clipRule="evenodd" d="M13.4857 5.3293C13.5995 4.93102 14.0146 4.7004 14.4129 4.81419L14.2069 5.53534C14.4129 4.81419 14.4129 4.81419 14.4129 4.81419L14.4144 4.81461L14.4159 4.81505L14.4192 4.81602L14.427 4.81834L14.4468 4.8245C14.4618 4.82932 14.4807 4.8356 14.5031 4.84357C14.548 4.85951 14.6074 4.88217 14.6802 4.91337C14.8259 4.97581 15.0249 5.07223 15.2695 5.21694C15.7589 5.50662 16.4271 5.9878 17.2121 6.77277C17.9971 7.55775 18.4782 8.22593 18.7679 8.7154C18.9126 8.95991 19.009 9.15897 19.0715 9.30466C19.1027 9.37746 19.1254 9.43682 19.1413 9.48173C19.1493 9.50418 19.1555 9.52301 19.1604 9.53809L19.1665 9.55788L19.1688 9.56563L19.1698 9.56896L19.1702 9.5705C19.1702 9.5705 19.1707 9.57194 18.4495 9.77798L19.1707 9.57194C19.2845 9.97021 19.0538 10.3853 18.6556 10.4991C18.2607 10.6119 17.8492 10.3862 17.7313 9.99413L17.7276 9.98335C17.7223 9.96832 17.7113 9.93874 17.6928 9.89554C17.6558 9.8092 17.5887 9.66797 17.4771 9.47938C17.2541 9.10264 16.8514 8.53339 16.1514 7.83343C15.4515 7.13348 14.8822 6.73078 14.5055 6.50781C14.3169 6.39619 14.1757 6.32909 14.0893 6.29209C14.0461 6.27358 14.0165 6.26254 14.0015 6.25721L13.9907 6.25352C13.5987 6.13564 13.3729 5.72419 13.4857 5.3293Z" fill="#1C274C" />
												</svg>
												<span className="ml-2">{addressData?.PhoneNumber}</span>
											</div>
											{/* Email Row (if present) */}
											{addressData?.Email && (
												<div className="flex items-center">
													<svg className="w-6 h-6" viewBox="0 0 32 32" id="svg5" version="1.1">
														<defs id="defs2" />
														<g id="layer1" transform="translate(-396,-52)">
															<path d="m 357,54 c -1.6447,0 -3,1.355301 -3,3 v 3 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 5 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 4.999997 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 3 c 0,1.6447 1.3553,3 3,3 h 17 c 1.6447,0 3,-1.3553 3,-3 V 57 c 0,-1.644699 -1.3553,-3 -3,-3 z m 48,0 c -1.6447,0 -3,1.355301 -3,3 v 3 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 5 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 4.999997 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 3 c 0,1.6447 1.3553,3 3,3 h 17 c 1.6447,0 3,-1.3553 3,-3 V 57 c 0,-1.644699 -1.3553,-3 -3,-3 z m -48,2 h 17 c 0.5713,0 1,0.428704 1,1 v 21.999997 c 0,0.5713 -0.4287,1 -1,1 h -17 c -0.5713,0 -1,-0.4287 -1,-1 v -3 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 V 69 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 v -5 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 v -3 c 0,-0.571296 0.4287,-1 1,-1 z m 48,0 h 17 c 0.5713,0 1,0.428704 1,1 v 21.999997 c 0,0.5713 -0.4287,1 -1,1 h -17 c -0.5713,0 -1,-0.4287 -1,-1 v -3 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 V 69 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 v -5 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 v -3 c 0,-0.571296 0.4287,-1 1,-1 z m -40,3 c -2.19729,0 -4,1.802713 -4,4 0,2.197287 1.80271,4 4,4 2.19729,0 4,-1.802713 4,-4 0,-2.197287 -1.80271,-4 -4,-4 z m 0,2 c 1.11642,0 2,0.883586 2,2 0,1.116414 -0.88358,2 -2,2 -1.11642,0 -2,-0.883586 -2,-2 0,-1.116414 0.88358,-2 2,-2 z m 49,0 c -3.85414,-10e-7 -7,3.145863 -7,7 0,3.854137 3.14586,6.999997 7,6.999997 a 0.99999499,0.99999499 0 0 0 1,-1 0.99999499,0.99999499 0 0 0 -1,-1 c -2.77327,0 -5,-2.22673 -5,-4.999997 0,-2.773265 2.22673,-5.000001 5,-5 2.77327,-10e-7 5.00002,2.226743 5,5 v 2 c 0,0.564133 -0.43587,0.999997 -1,0.999997 -0.56413,0 -1,-0.435866 -1,-0.999997 v -2 c 0,-1.645003 -1.35499,-2.999997 -3,-3 -1.64501,3e-6 -3,1.354997 -3,3 0,1.645003 1.35499,2.999997 3,2.999997 0.39113,0 0.76536,-0.0779 1.10938,-0.21679 0.34849,1.27043 1.51634,2.21679 2.89062,2.21679 1.64501,1e-5 3,-1.35499 3,-2.999997 v -2 c 2e-5,-3.854137 -3.14586,-7.000001 -7,-7 z m 0,6 c 0.56413,10e-7 1,0.435868 1,1 0,0.564132 -0.43587,0.999999 -1,1 -0.56413,-10e-7 -1,-0.435868 -1,-1 0,-0.564132 0.43587,-0.999999 1,-1 z m -51,1 c -2.1987,0 -4,1.801301 -4,3.999997 0,2.1987 1.8013,4 4,4 h 4 c 2.1987,0 4,-1.8013 4,-4 C 371,69.801301 369.1987,68 367,68 Z m 0,2 h 4 c 1.1253,0 2,0.874707 2,1.999997 0,1.1253 -0.8747,2 -2,2 h -4 c -1.1253,0 -2,-0.8747 -2,-2 C 361,70.874707 361.8747,70 363,70 Z" id="rect35136" />
														</g>
													</svg>
													<span className="ml-2">{addressData?.Email}</span>
												</div>
											)}
										</div>
									</div>

								))}
							</div>
						</>}

					</div>}
			</div>

		</div>


	)
}

export default CustomerAddressBookMobile

